import { AmbientSound } from '@/types';

// 使用Moodist项目的高质量音频文件 (MIT许可)
export const AMBIENT_SOUNDS: AmbientSound[] = [
  {
    id: 'whitenoise',
    name: '白噪声',
    icon: '⚪',
    url: '/sounds/white-noise.wav',
    category: 'noise'
  },
  {
    id: 'pinknoise',
    name: '粉噪声',
    icon: '🌸',
    url: '/sounds/pink-noise.wav',
    category: 'noise'
  },
  {
    id: 'brownnoise',
    name: '棕噪声',
    icon: '🟤',
    url: '/sounds/brown-noise.wav',
    category: 'noise'
  },
  {
    id: 'rain',
    name: '雨声',
    icon: '🌧️',
    url: '/sounds/rain.mp3',
    category: 'nature'
  },
  {
    id: 'ocean',
    name: '海浪',
    icon: '🌊',
    url: '/sounds/ocean.mp3',
    category: 'nature'
  },
  {
    id: 'forest',
    name: '森林',
    icon: '🌿',
    url: '/sounds/forest.mp3',
    category: 'nature'
  },
  {
    id: 'campfire',
    name: '篝火',
    icon: '🔥',
    url: '/sounds/campfire.mp3',
    category: 'nature'
  },
  {
    id: 'coffeeshop',
    name: '咖啡店',
    icon: '☕',
    url: '/sounds/coffee-shop.mp3',
    category: 'urban'
  },
  {
    id: 'library',
    name: '图书馆',
    icon: '📚',
    url: '/sounds/library.mp3',
    category: 'urban'
  }
];

export const AMBIENT_CONFIG = {
  defaultVolume: 0.5,
  fadeInDuration: 1000,
  fadeOutDuration: 500,
  storageKey: 'ambient-player-state'
};